/*
 * Copyright (c) 2026. Bolmate B.V.
 */

import React, {useContext, useState} from 'react';
import {useLocation} from 'react-router';
import {useTranslation} from 'react-i18next';
import {ResponseData, showDialog} from '@dvrd/dvr-controls';
import {AppContext} from '../misc/appContext';
import {submitFeedback} from '../../util/requestSender';
import {createErrorMessage} from '../../util/utils';
import {onShowConfirmSnackbar} from '../../util/renderUtil';
import FeedbackDialog from './feedbackDialog';

interface Props {
    active: boolean;
    onClose: VoidFunction;
}

export default function FeedbackDialogController(props: Props) {
    const {t} = useTranslation();
    const location = useLocation();
    const context = useContext(AppContext);
    const {account} = context.accountContext;
    const {active, onClose} = props;
    const [feedback, setFeedback] = useState('');
    const [loading, setLoading] = useState(false);

    function onCloseDialog() {
        onClose();
        window.setTimeout(() => {
            setFeedback('');
            setLoading(false);
        });
    }

    function onChangeFeedback(value: string) {
        setFeedback(value);
    }

    function onSubmit() {
        if (!feedback.trim().length || account === null || loading) return;
        setLoading(true);
        submitFeedback({
            data: {
                account_id: account.id,
                feedback,
                current_path: location.pathname + location.search
            },
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    onCloseDialog();
                    onShowConfirmSnackbar(t('feedback.thanksSnackbar', 'Bedankt voor je feedback!'));
                } else
                    showDialog(
                        createErrorMessage(
                            data.message ??
                                t('feedback.sendErrorMessage', 'Het verzenden van de feedback is niet gelukt.')
                        ),
                        t('feedback.sendErrorTitle', 'Verzenden mislukt')
                    );
            }
        });
    }

    return (
        <FeedbackDialog
            active={active}
            onClose={onCloseDialog}
            onChangeFeedback={onChangeFeedback}
            onSubmit={onSubmit}
            feedback={feedback}
            loading={loading}
        />
    );
}
